export default __webpack_public_path__ + "static/media/SJA1430.34I-42057_-25200_0.dc8eb169.jpg";